/***
 *
 *   HUBSPOT COMPLETE — DESTINATION
 *   Decides where a user goes after the HubSpot OAuth return, and whether
 *   onboarding should be marked finished on the way.
 *
 *   One connector return URL serves both a brand-new user partway through
 *   /welcome and an existing admin reconnecting from /account/integrations, so
 *   the branch has to happen client-side where the session is known.
 *
 *   Two constraints drive it:
 *   - The destination below, /account/integrations/hubspot, is permission:
 *     "admin" (client/src/routes/account.js), and PrivateRoute sends a user who
 *     lacks a route's permission to /signin. Sending a non-admin there would
 *     look like being signed out mid-OAuth. Not every /account/ route is
 *     admin-only -- profile, password and 2fa are "user" -- but this one is.
 *   - A user who has not onboarded must have that flag set, or auth.js returns
 *     them to /welcome on their next sign-in.
 *
 *   Kept dependency-free and separate from the view so it stays directly
 *   testable without rendering.
 *
 **********/

export function nextDestination({ onboarded, isAdmin } = {}) {
  if (!onboarded) {
    // finishing onboarding takes precedence over the settings destination,
    // including for an admin — otherwise the flag never gets set
    return { path: "/dashboard", markOnboarded: true };
  }

  return {
    path: isAdmin ? "/account/integrations/hubspot" : "/dashboard",
    markOnboarded: false,
  };
}
